import { render, staticRenderFns } from "./DocumentTypeModal.vue?vue&type=template&id=54cdeb5c&scoped=true"
import script from "./DocumentTypeModal.vue?vue&type=script&lang=js"
export * from "./DocumentTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cdeb5c",
  null
  
)

export default component.exports